import domtoimage from 'dom-to-image-more';
import moment from 'moment'

const utils = {
    formatTime: function(unixTimestamp) {
        if (!unixTimestamp) return '';
        let date = new Date(unixTimestamp);
        let datetext = date.toTimeString();
        let timeArr = datetext.split(' ')[0].split(':').slice(0, 2);
        return timeArr.join(':');
    },

    formatToMySQLDate: function(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
    
        return [year, month, day].join('-');
    },

    formatStrTime: function(strTime) {
        return strTime && strTime.length>2 ? strTime.substr(0, strTime.length-2) + ':' + strTime.substr(-2) + 'hs' : '';
    },

    formatHorario: function(horario) {
        let horas = Math.floor(horario / 100); // Obtiene las horas (ej: 930 → 9)
        let minutos = horario % 100; // Obtiene los minutos (ej: 930 → 30)
        return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}hs`; 
    },

    formatDateTime: function(unixTimestamp) {
        if (!unixTimestamp) return '';
        return moment(unixTimestamp).format('DD-MM-YYYY HH:mm');
    },

    capitalize: function(str) {
        return str && str.length ? `${str[0].toUpperCase()}${str.slice(1)}` : '';
    },

    abbreviate: function(persona, maxLength=0) {
        
        if (!persona || !persona.apellido || !persona.nombre) return '';

        let apellido = persona.apellido.toUpperCase();
        let nombre = persona.nombre.charAt(0).toUpperCase();

        if (maxLength>0 && apellido.length > maxLength-3) apellido = apellido.substr(0, maxLength-3);

        // strip apellido and leave only first one
        if (maxLength==-1) {
            let apellidoArr = apellido.split(' ');
            if (apellidoArr.length > 1) {
                apellido = apellidoArr.map((part, index) => index ? part.substr(0,1) : part).join(' ');
            }
        }

        return `${apellido}, ${nombre}`;
    },

    copy(obj) {
        return JSON.parse(JSON.stringify(obj));
    },

    adaptJugador(jugador) {
        // Precargar numero_camiseta si existe y es válido (entre 2 y 98)
        if (jugador.numero_camiseta !== null && jugador.numero_camiseta !== undefined && jugador.numero_camiseta !== '') {
            const numeroCamiseta = Number(jugador.numero_camiseta);
            if (!isNaN(numeroCamiseta) && numeroCamiseta > 0 && numeroCamiseta <= 99) {
                jugador.numero = numeroCamiseta;
            } else {
                jugador.numero = '';
            }
        } else {
            jugador.numero = '';
        }
        jugador.estado = 'habilitado'
        jugador.rol = [];
        return jugador;
    },

    indexOfMax(arr) {
        var max = 0;
        var maxIndex = 0;

        arr.forEach(function (value, i) {
            if (value > max) {
                maxIndex = i;
                max = value;
            }
        })
    
        return maxIndex;
    },

    screenshotAndUpload: async function() {
        
        const el = document.getElementById('match');

        const scale = window.devicePixelRatio;

        const dataUrl = await domtoimage.toPng(el, {
            height: el.offsetHeight * scale,
            width: el.offsetWidth * scale,
            style: {
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
                width: `${el.offsetWidth}px`,
                height: `${el.offsetHeight}px`
            }            
        });

        return await this.uploadImageToCloudinary(dataUrl);
    },

    uploadImageToCloudinary: async function (dataUrl) {
        
        const cloudName = 'dqh0uihlk';
        const uploadPreset = 'courtrack-ruler';

        const formData = new FormData();
        formData.append('file', dataUrl);
        formData.append('upload_preset', uploadPreset);
      
        try {

            const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
                method: 'POST',
                body: formData
            })
      
            const data = await response.json();

            if (data.secure_url) {

                return data.secure_url;
            
            } else {

                console.log('ER', data.error);

                throw new Error('Error desconocido al subir la imagen.');
            }

        } catch (error) {
            console.log(error);
        }
    }
}

export default utils;